<template>
  <div ref="container">
    <b-alert show variant="success" dismissible v-on:dismiss="$emit('dismiss')">
      <h4 class="alert-heading">Member emails imported!</h4>
      <hr />
      <p class="mb-0">
        <strong>Emails added:</strong>
        {{ results.emails.inserted }}
      </p>
      <p class="mb-0">
        <strong>Emails updated:</strong>
        {{ results.emails.updated }}
      </p>
      <p class="mb-0">
        <strong>Emails deleted:</strong>
        {{ results.emails.deleted }}
      </p>
      <hr />
      <p class="mb-0">
        <strong>Number of active users:</strong>
        {{ results.users.active }}
      </p>
      <p class="mb-0">
        <strong>Number of disabled users:</strong>
        {{ results.users.disabled }}
      </p>
      <hr />
      <p class="mb-0">
        <strong>Total rows:</strong>
        {{ results.rows.total }}
      </p>
    </b-alert>
  </div>
</template>

<script>
export default {
  name: 'SocietyCSVUploadResults',
  props: {
    results: [Array, Object],
  },
  watch: {
    results: {
      immediate: true,
      handler: function (currVal) {
        if (currVal) {
          this.$nextTick(() => {
            if (this.$refs.container) {
              this.$refs.container.scrollIntoView();
            }
          });
        }
      },
    },
  },
};
</script>

<style scoped></style>
